import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { ROUTE_CLIENTS } from "../../SharedModule/utils/constants";
import { ClientsService } from "../services/clients";
import {
  setActualClientForHeaderInfo,
  setIsActualClientForHeaderInfoLoading,
} from "../redux/reducers/clientsList.reducer";

// Shared by useClientBillingInfo and useClientEdit: fetches the client's
// header info if it isn't already loaded for this clientId, guarding against
// concurrent/stale invocations the same way both hooks' effects do. See
// useClientBillingInfo's inFlightRef/doneRef comment for why both guards are
// needed - this helper doesn't own that state, it's passed in by the caller.
export const loadHeaderInfoIfNeeded = async (
  inFlightRef,
  doneRef,
  clientId,
  clientForHeaderInfo,
  dispatch,
  navigate
) => {
  if (
    inFlightRef.current.header ||
    doneRef.current.header === clientId ||
    (clientForHeaderInfo && clientForHeaderInfo.id === clientId)
  ) {
    return;
  }
  inFlightRef.current.header = true;
  dispatch(setIsActualClientForHeaderInfoLoading(true));
  const headerInfo = await ClientsService.getClientModuleHeaderInfo(clientId)
    .then((response) => {
      if (!response.success) {
        dispatch(
          addToast({
            mode: "error",
            message: response.message,
          })
        );
        dispatch(setIsActualClientForHeaderInfoLoading(false));
        navigate(ROUTE_CLIENTS);
        return true;
      }
      return response.data;
    })
    .catch(() => {
      dispatch(
        addToast({
          mode: "error",
          message:
            "Something wrong happened while getting the client header information.",
        })
      );
      dispatch(setIsActualClientForHeaderInfoLoading(false));
      navigate(ROUTE_CLIENTS);
      return true;
    });
  inFlightRef.current.header = false;
  doneRef.current.header = clientId;
  dispatch(setActualClientForHeaderInfo(headerInfo));
};
